class CustomCartNotification extends HTMLElement {
    open() {
        this.cart = document.querySelector('cart-drawer');
        if(this.cart.classList.contains('active')) return 
        this.classList.add('show');
        setTimeout(() => this.close(), 3000);
    }

    close() {
        this.classList.remove('show');
    }
    renderContents(parsedState) {
        const sectionElement = this.getSectionToRender().selector
        ? document.querySelector(this.getSectionToRender().selector)
        : document.getElementById(this.getSectionToRender().id);
        if (!sectionElement) return; 
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[this.getSectionToRender().id], this.getSectionToRender().selector);
        
        this.open();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    getSectionToRender() {
        return  {
            id: 'custom-cart-notification',
            selector:'.cart-notification-render-wrap'
        }
    }
}

customElements.define('custom-cart-notification', CustomCartNotification);